import { render, staticRenderFns } from "./MedicineRefrigeratorView.vue?vue&type=template&id=7c25e047&"
import script from "./MedicineRefrigeratorView.vue?vue&type=script&lang=js&"
export * from "./MedicineRefrigeratorView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports